<template>
  <div class="clearfix">
    <b-table striped small hover :items="siglesourcesData" :per-page="perPage" :current-page="currentPage">
      <template #cell(siglesourceCode)="data">
        <span v-html="data.item.siglesourceCode" />
      </template>
      <template #cell(alternativeSigle)="data">
        <span v-html="data.item.alternativeSigle" />
      </template>
      <template #cell(id)="data">
        <tdColUUID :value="data.item.id" />
      </template>
      <template #cell(action)="data">
        <div class="text-right">
          <!-- <router-link :to="{ name: 'EditionDetails', params: {
            slug: data.item.action.sigleLegamNormalized,
            id: data.item.action.id
          }}">
            <b-icon icon="link45deg"></b-icon>
          </router-link> -->
          <a
            href="#"
            v-if="editMode"
            @click="editRow($event, data.item.action.sigleSourceRel)"
            ><b-icon icon="pencil"></b-icon
          ></a>
          <a href="#" v-if="editMode" @click="deleteRow($event, data.item.action.id)"><b-icon icon="trash"></b-icon></a>
        </div>
      </template>
    </b-table>
    <b-col sm="4" md="3" class="float-left" v-if="showTotalLable">
      Total {{ totalRows }} {{ totalRows === 1 ? 'entry' : "entries" }} in table
    </b-col>
    <b-col sm="3" md="2" class="my-1 float-right" v-if="totalRows > 10">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        size="sm"
        class="my-0"
        first-number
        last-number
      ></b-pagination>
    </b-col>
  </div>
</template>

<style scoped>
  * >>> th {
    font-size: 10px !important;
    text-transform: uppercase;
    color: #bbbbbb;
  }
</style>

<script>
  import tdColUUID from '@/components/tdColUUID.vue'

  export default {
    name: 'SigleSourceRelTable',
    props: ['siglesourcesRel', 'editMode', 'showTotal'],
    data(){
      return {
        currentPage: 1,
        totalRows: this.siglesourcesRel.length,
        perPage: 10,
        showTotalLable: this.showTotal ? this.showTotal : false
      }
    },
    components: {
      tdColUUID,
    },
    methods: {
      deleteRow(event, siglesourceId){
        event.preventDefault()
        this.$store.dispatch('addNotification', {
          type: 'warning',
          text: `Sigle source deleted`
        })
        this.$emit('delete', siglesourceId)
      },
      editRow(event, sigleSourceRel) {
        event.preventDefault();
        this.$emit("edit", sigleSourceRel);
      },
    },
    computed: {
      siglesourcesData(){
        return this.siglesourcesRel ? this.siglesourcesRel.map((sigleSourceRel, index) => {
          sigleSourceRel['_index'] = index;
          return {
            id: sigleSourceRel.id,
            siglesourceCode: sigleSourceRel.siglesourceCode,
            alternativeSigle: sigleSourceRel.alternativeSigle,
            action: {
              id: sigleSourceRel.id,
              code: sigleSourceRel.siglesourceCode,
              sigleSourceRel: sigleSourceRel
            }
          }
        }) : []
      }
    }
  }
</script>
